export function buildDynamicLabel(name: string, id?: number | string): string {
    return `${name}--${id}`;
}
export function buildDropdownOption(name: string, option?: number | string): string {
    return `${name}-${option}`;
}

export function replaceVariableOnStringChain(chain:string, value:number | string):string {
    return chain.replace(/\${([^}]*)}/g, value.toString())
}

export function formatDate(inputDate: string): string {
    const date = new Date(inputDate);

    if (isNaN(date.getTime())) {
        // Handle invalid date string
        return 'Invalid Date';
    }

    const day = addOrdinalSuffix(date.getDate());
    const month = date.toLocaleString('en-US', { month: 'long' });
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;

    const formattedDate = `${day} ${month} ${formattedHours}:${minutes.toString().padStart(2, '0')} ${period}`;

    return formattedDate;
}

export function addOrdinalSuffix(n: number): string {
    const suffixes = ["st", "nd", "rd", "th"];
    const v = n % 100;

    return n + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[3]!);
}